document.addEventListener('DOMContentLoaded', () => {
    if(document.getElementById("brux-scroller")){
        window.addEventListener('scroll', (event) => {
            const el = document.getElementById("brux-scroller");
            const observer = new IntersectionObserver( 
                ([e]) => {
                    e.target.classList.toggle("is-pinned", e.intersectionRatio < 1),
                    e.target.classList.toggle("tw-is-pinned", e.intersectionRatio < 1),
                    { 
                        threshold: [1]
                    }
                }
            );                
            observer.observe(el);
        })           
    }
  });